<div class="panel-options-body">
    <div class="form form-horizontal">
        <div class="form-row">
            <div class="form-group" [class.mb-10]="availablePaymentMethods()?.[type.value]">
                <div class="type-dropdown-default col-xs-12" dropdown>
                    <button class="btn btn-default dropdown-toggle custom-btn" data-toggle="dropdown" dropdownToggle>
                        <div class="strip-text">
                            <img [src]="getPaymentIconSrc(type.value)" [alt]="type.value" />
                            <span class="strip-text">{{ paymentsList[type.value]?.label | translate }}</span>
                        </div>
                        <span class="caret"></span>
                    </button>

                    @if (isDisabledPaymentMethodSelectForCart()) {
                        @if (isCustomPaymentType) {
                            <div class="dropdown-menu paid" *dropdownMenu>
                                <span class="badge badge-paid">&nbsp;</span>
                                {{ "payment_method_select_paid_only" | translate }}
                            </div>
                        } @else {
                            <ul class="dropdown-menu" *dropdownMenu>
                                <li (click)="setType(EPaymentType.custom)">
                                    <img
                                        [src]="getPaymentIconSrc(EPaymentType.custom)"
                                        [alt]="paymentsList[EPaymentType.custom]?.label | translate"
                                    />
                                    <span>{{ paymentsList[EPaymentType.custom]?.label | translate }}</span>
                                </li>
                            </ul>
                        }
                    } @else {
                        <ul class="dropdown-menu" *dropdownMenu>
                            @for (payment of paymentsList | keyvalue: paymentIndexOrder; track payment) {
                                @if (!payment.value.hidden) {
                                    <li
                                        [class.hide]="type.value === payment.value.type"
                                        (click)="setType(payment.value.type)"
                                    >
                                        <img
                                            [src]="getPaymentIconSrc(payment.value.type)"
                                            [alt]="payment.value.label | translate"
                                        />
                                        <span>{{ payment.value.label | translate }}</span>
                                    </li>
                                }
                            }
                        </ul>
                    }
                    @if (availablePaymentMethods()?.[type.value] === false) {
                        <div class="help-block small">
                            <span class="sp-icon icon-warning color-warning"> </span>
                            {{ "payment_method_is_not_active" | translate }}
                            <a class="dashed" href="/settings/#payment-systems" target="_blank">{{
                                "enable" | translate
                            }}</a>
                        </div>
                    }
                </div>
            </div>

            @if (availablePaymentMethods()?.[type.value] && paymentMethodsByType?.length > 1) {
                <div class="form-group mb-10">
                    <div class="type-dropdown-default col-xs-12" dropdown>
                        <button
                            class="btn btn-default dropdown-toggle custom-btn"
                            data-toggle="dropdown"
                            dropdownToggle
                        >
                            <div class="strip-text">
                                <span class="strip-text">{{ paymentMethodByType.name }}</span>
                            </div>
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu chat-bots-dropdown" *dropdownMenu>
                            @for (payment of paymentMethodsByType; track payment) {
                                <li
                                    [class.selected]="paymentMethodId.value === payment.id"
                                    (click)="setPaymentMethodId(payment)"
                                >
                                    <span>{{ payment.name }}</span>
                                </li>
                            }
                        </ul>
                    </div>
                </div>
            }
            @if (isCustomPaymentType) {
                <div class="form-group" [class.has-error]="customPaymentName.invalid">
                    <div class="col-xs-12">
                        <label class="control-label">
                            {{ "control_custom_payment_label" | translate }}
                        </label>
                        <span class="help-block small">
                            {{ "control_custom_payment_label_hint" | translate }}
                        </span>
                    </div>
                    <div class="col-xs-12">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="{{ 'custom_payment_label' | translate }}"
                            [formControl]="customPaymentName"
                        />
                        @if (customPaymentName.hasError("required")) {
                            <span class="help-block small">
                                {{ "control_errors_required" | translate }}
                            </span>
                        }
                    </div>
                </div>
            }

            @if (!isCustomPaymentType) {
                <div class="form-group" [class.has-error]="newPaymentName.invalid">
                    <div class="col-xs-12">
                        <label class="control-label">
                            {{ "control_custom_payment_label" | translate }}
                        </label>
                        <span class="help-block small">
                            {{ "control_custom_payment_label_hint" | translate }}
                        </span>
                    </div>
                    <div class="col-xs-12">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="{{ 'custom_payment_label' | translate }}"
                            [formControl]="newPaymentName"
                        />
                        @if (newPaymentName.hasError("required")) {
                            <span class="help-block small">
                                {{ "control_errors_required" | translate }}
                            </span>
                        }
                    </div>
                </div>
            }

            @if (availablePaymentMethods()?.[type.value] && !shopCurrency()) {
                <div class="form-group">
                    <div [class.col-xs-6]="isCustomPaymentType" [class.col-xs-7]="!isCustomPaymentType">
                        <select class="form-control" [formControl]="isEditableTotalCost">
                            <option [ngValue]="false">{{ "control_indicated_price" | translate }}</option>
                            <option [ngValue]="true">{{ "control_minimal_price" | translate }}</option>
                        </select>
                    </div>
                    <div
                        [class.col-xs-6]="isCustomPaymentType"
                        [class.col-xs-5]="!isCustomPaymentType"
                        [class.has-error]="amount.invalid"
                    >
                        @if (isCustomPaymentType) {
                            <sp-input-num
                                [min]="amountConfig.min"
                                [max]="amountConfig.max"
                                [step]="amountConfig.step"
                                placeholder="0.00"
                                [value]="amount.value"
                                (valueChange)="setAmount($event)"
                                [suffixList]="paymentCurrenciesList"
                                [suffixValue]="currency.value"
                                (suffixChangeEvent)="setCurrency($event)"
                            />
                        } @else {
                            <sp-input-num
                                [min]="amountConfig.min"
                                [max]="amountConfig.max"
                                [step]="amountConfig.step"
                                placeholder="0.00"
                                [suffixText]="currency.value"
                                [value]="amount.value"
                                (valueChange)="setAmount($event)"
                            />
                        }
                    </div>
                    @if (isCryptomusPaymentType) {
                        <div class="col-xs-12 help-block small">
                            {{ "help_text_cryptomus" | translate }}
                        </div>
                    }
                </div>
            }

            @if (type.value === EPaymentType.liqpay && availablePaymentMethods()?.[type.value] && showRroSettings()) {
                <div class="form-group" [class.mb-10]="rroIsActive.value">
                    <label class="control-label col-xs-10">
                        {{ "liqpay_rro_label" | translate }}
                        <span
                            class="small sp-icon icon-question color-light hover-effect"
                            [popover]="ppoTooltip"
                            [outsideClick]="true"
                            triggers="mouseenter"
                        ></span>
                        <ng-template #ppoTooltip>
                            <span>{{ "liqpay_rro_help" | translate }}</span>
                            <br />
                            <a [href]="rroLiqHelpLink" target="_blank"
                                >{{ "ligpay_rro_help_link" | translate }}
                                <small class="sp-icon icon-outgoing small-xs color-light"></small
                            ></a>
                        </ng-template>
                    </label>
                    <div class="col-xs-2 control-switch text-right">
                        <sp-switch [active]="rroIsActive.value" (toggleActiveEvent)="setRroIsActive($event)" />
                    </div>
                </div>
                @if (rroIsActive.value) {
                    <div class="form-group">
                        <div class="col-xs-12">
                            <div class="input-group" [class.has-error]="id.invalid">
                                <span class="input-group-addon" id="liqpay-id">{{ "liqpay_rro_id" | translate }}</span>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="123456"
                                    aria-describedby="liqpay-id"
                                    [formControl]="id"
                                    [value]="id.value"
                                />
                            </div>
                            @if (id.hasError("required")) {
                                <small [class.text-error]="id.invalid">
                                    {{ "control_errors_required" | translate }}
                                </small>
                            }
                        </div>
                    </div>
                }
            }
            @if (type.value === EPaymentType.monobank && availablePaymentMethods()?.[type.value] && showRroSettings()) {
                <div class="form-group" [class.mb-10]="rroIsActive.value">
                    <label class="control-label col-xs-10">
                        {{ "liqpay_rro_label" | translate }}
                        <span
                            class="small sp-icon icon-question color-light hover-effect"
                            [popover]="ppoTooltip"
                            [outsideClick]="true"
                            triggers="mouseenter"
                        ></span>
                        <ng-template #ppoTooltip>
                            <span>{{ "liqpay_rro_help" | translate }}</span>
                            <br />
                            <!--                            <a [href]="rroMonoHelpLink" target="_blank">{{ 'ligpay_rro_help_link' | translate }} <small class="sp-icon icon-outgoing small-xs color-light"></small></a>-->
                        </ng-template>
                    </label>
                    <div class="col-xs-2 control-switch text-right">
                        <sp-switch [active]="rroIsActive.value" (toggleActiveEvent)="setRroIsActive($event)" />
                    </div>
                </div>
                @if (rroIsActive.value) {
                    <div class="form-group">
                        <div class="col-xs-12">
                            <div class="input-group" [class.has-error]="id.invalid">
                                <span class="input-group-addon" id="mono-id">{{ "liqpay_rro_id" | translate }}</span>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="123456"
                                    aria-describedby="mono-id"
                                    [formControl]="id"
                                    [value]="id.value"
                                />
                            </div>
                            @if (id.hasError("required")) {
                                <small [class.text-error]="id.invalid">
                                    {{ "control_errors_required" | translate }}
                                </small>
                            }
                        </div>
                    </div>
                }
            }
            @if (isCustomPaymentType) {
                <div class="form-group">
                    <div class="col-xs-12">
                        <div class="alert alert-info-mutted alert-sm">
                            {{ "custom_payment_notify" | translate }}
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
